import HttpStatus from "http-status-codes";
import { type NextApiHandler } from "next";
import { object, string } from "yup";
import { api } from "~/lib/api";
import { sendMarketDataSearchEmail } from "~/lib/external/sendinblue/templates";
import { getRequiredUser } from "~/lib/getRequiredUser";

export const SendMarketDataSearchSchema = object({
  email: string().email().required(),
  body: string().required(),
  hash: string().required(),
});

export const MarketDataButtonPlaceholder = "[[button to access market data]]";

const handler: NextApiHandler = async (req, res) => {
  const input = SendMarketDataSearchSchema.validateSync(req.body, {
    abortEarly: false,
  });

  await sendMarketDataSearchEmail(req, {
    user: getRequiredUser(req),
    ...input,
  });

  res.status(HttpStatus.OK).json({
    message: "Email sent",
  });
};

export default api(handler, {
  method: "POST",
  authentication: {},
});
